module.exports = __webpack_public_path__ + "static/img/7.54efe65.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/7.png
// module id = gbtI
// module chunks = 3